import { faker } from '@faker-js/faker';
import { Factory, trait } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.name.fullName();
  },

  shortName() {
    return this.name.substring(0, 3);
  },

  type() {
    return 'test-type';
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsModified() {
    return faker.date.past();
  },

  articleType: trait({
    name() {
      const options = ['Pressezitat', 'Insight', 'Termine ', 'Blog', 'Lyric'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'A_TYPE';
    },
  }),

  calendarEventType: trait({
    name() {
      const options = ['Jahrestag', 'Todestag', 'Uraufführung ', 'Geburtstag'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'T_TYPE_CAL';
    },
  }),

  contributorFunction: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'CONTRIB_FUNC';
    },
  }),

  country: trait({
    name() {
      const options = ['Deutschland', 'Frankreich', 'Niederlande', 'Schweiz'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'COUNTRY';
    },
  }),

  embedService: trait({
    name() {
      const options = ['YouTube', 'Apple Music', 'Spotify', 'TikTok'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'MEDIA_EMBED';
    },
  }),

  externalReferenceType: trait({
    name() {
      const options = ['Instagram Feed', 'Snapchat', 'Pinterest', 'Twitter'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'EXT_SERVICE';
    },
  }),

  gender: trait({
    name() {
      const options = ['Frau', 'Herr', 'Firma'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'GENDER';
    },
  }),

  organizationType: trait({
    name() {
      const options = [
        'Vermarkter',
        'Zeitung',
        'Kleidung',
        'Verkehr',
        'Agentur',
      ];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'P_TYPE_COOP';
    },
  }),

  partnerTypeCoop: trait({
    name() {
      const options = [
        'Vermarkter',
        'Zeitung',
        'Kleidung',
        'Verkehr',
        'Agentur',
      ];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'P_TYPE_COOP';
    },
  }),

  partnerTypeLive: trait({
    name() {
      const options = ['Location', 'Booker', 'Festival', 'Ticketseller'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'P_TYPE_LIVE';
    },
  }),

  partnerTypeMedia: trait({
    name() {
      const options = ['ARD', 'ZDF', 'BR 5', 'RBB', 'Radio Bremen', 'SWR'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'P_TYPE_MEDIA';
    },
  }),

  partnerTypeOnOff: trait({
    name() {
      const options = ['Online', 'Offline'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'P_TYPE_ONOFF';
    },
  }),

  partnerTypeTrade: trait({
    name() {
      const options = [
        'Online-Händler ',
        'Jazz Fachhändler',
        'Tickets',
        'Klassikhändler',
      ];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'P_TYPE_TRADE';
    },
  }),

  position: trait({
    name() {
      const options = ['Assistant ', 'Senior Controller', 'Print', 'TV'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'POSITION';
    },
  }),

  productCategory: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'PRODUCTCATEGORY';
    },
  }),

  productConfiguartion: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'CONFIGURATION';
    },
  }),

  productFamily: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'PRODUCTFAMILY';
    },
  }),

  productSubCategory: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'PRODUCTSUBCATEGORY';
    },
  }),

  productDeliveryState: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'DELIVERYSTATE';
    },
  }),

  mixedCategories: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      const options = ['TYPE_ONE', 'TYPE_TWO'];

      return faker.helpers.arrayElement(options);
    },
  }),

  productGroup: trait({
    name() {
      const options = ['Artist', 'Shaker', 'Guitar ', 'Voice'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'PRODUCTGROUP';
    },
  }),

  region: trait({
    name() {
      const options = [
        'Berlin ',
        'Brandenburg',
        'Niedersachen',
        'Tirol',
        'Wien',
        'Hamburg',
      ];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'PROVINCE';
    },
  }),

  jobType: trait({
    name() {
      const options = ['Profesional ', 'Student'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'JOB_TYPE';
    },
  }),

  shopTyp: trait({
    name() {
      const options = ['Streaming ', 'Prelistening', 'Shop'];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'SHOP_TYPE';
    },
  }),

  shop: trait({
    name() {
      const options = [
        'Apple Music Playlist ',
        'Amazon Music',
        'Deezer',
        'MediaMarkt',
        'Saturn',
      ];

      return faker.helpers.arrayElement(options);
    },

    type() {
      return 'SHOP';
    },
  }),
});
